import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';

export const formatTimeAgo = (date: string | Date): string => {
	const dateObj = typeof date === 'string' ? new Date(date) : date;
	return formatDistanceToNow(dateObj, { addSuffix: true, locale: es });
};
